import { GuidesReader } from '../components/GuidesReader';

/** Central "Help & Guides" hub — browse every guide available to your role. */
export function GuidesHubPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Help &amp; Guides</h1>
        <p className="text-muted-foreground mt-1 text-sm">
          Short, practical guides on how each part of the workspace works — and why it&apos;s
          there. Pick a topic to get started.
        </p>
      </div>
      <GuidesReader />
    </div>
  );
}
